
import { Component, Input, Output, EventEmitter, AfterViewInit, OnInit } from '@angular/core';
import { WsService } from '../../utils/network/ws.service';
import { SessionManagerService } from '../services/session/session-manager.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { DesksService } from './desks.service';
import { WbService } from '../wb.service';
@Component({
    selector: "dskl-wb-desks-menu",
    templateUrl: 'desks-menu.component.html',

})
export class DesksMenuComponent implements OnInit {
    @Input() board;
    @Input() emitSelectedDesk = false;
   // @Input() currentWbType;
    @Output() selected = new EventEmitter();
    currentItem = null;
    @Input() up=false;
    desks=[]
    ngOnInit() {
        this.desks = this.desksService.getDesks(); 
        for (var d of this.desks) {
            if (this.board && d.value == this.board.wbType) {
                this.currentItem = d;
            }
        }
    }

    constructor(private wbService: WbService, private wsService: WsService, private translate: TranslateService, private desksService:DesksService, private sessionManager: SessionManagerService ) { }
    

    onSelected(o, i) {
        this.selected.emit({ desk: o, index: i });
        if (this.emitSelectedDesk){
            console.log(o)
             this.sessionManager.changeDesk(this.board.column, this.board.boardId, o.value)
             this.wbService.setShowChat(o.value!='CHAT');
        }
    }
    
    selectedDesk(o) {
        console.log("Selected desk ", o.desk.value);
        this.sessionManager.getCurrentStates(false);
        this.sessionManager.changeDesk(this.board.column, this.board.boardId, o.desk.value)

    }
}


// WEBPACK FOOTER //
// /app/src/app/wb/desksmenu/desks-menu.component.ts